import { render, staticRenderFns } from "./CenterViewOrderHistory_Ap.vue?vue&type=template&id=958dfec4&scoped=true"
import script from "./CenterViewOrderHistory_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewOrderHistory_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewOrderHistory_Ap.vue?vue&type=style&index=0&id=958dfec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958dfec4",
  null
  
)

export default component.exports